import React from "react";
import LegalPageLayout, { Section, SectionTitle, Paragraph, List } from "components/legal/LegalPageLayout.js";
import tw from "twin.macro";

const Table = tw.table`w-full text-sm border-collapse mb-6`;
const Th = tw.th`border border-gray-300 px-4 py-2 text-left bg-gray-100 font-bold`;
const Td = tw.td`border border-gray-300 px-4 py-2 text-secondary-100`;

const templates = [
  { id: "VIPSO-OTP-001", type: "OTP", product: "VIPSO", message: "{#var#} is your OTP for VIPSO login. Do not share. - Spurnest" },
  { id: "VIPSO-TXN-001", type: "Transactional", product: "VIPSO", message: "Your order #{#var#} has been confirmed on VIPSO. - Spurnest" },
  { id: "VIPSO-SUB-001", type: "Transactional", product: "VIPSO", message: "Your VIPSO subscription renews on {#var#}. Manage at Play Store. - Spurnest" },
  { id: "MA-OTP-001", type: "OTP", product: "Mind Aspirants", message: "{#var#} is your OTP for Mind Aspirants. Valid for 10 mins. - Spurnest" },
  { id: "MA-TXN-001", type: "Transactional", product: "Mind Aspirants", message: "You scored {#var#} points in {#var#} quiz! Check leaderboard. - Mind Aspirants" },
  { id: "MA-TXN-002", type: "Transactional", product: "Mind Aspirants", message: "Congratulations! You won Rs.{#var#} in {#var#} quiz. - Mind Aspirants" },
  { id: "MA-PRM-001", type: "Promotional", product: "Mind Aspirants", message: "New quiz live! Play {#var#} and win up to Rs.{#var#}. - Mind Aspirants" },
];

export default () => {
  return (
    <LegalPageLayout
      productName="Spurnest Techlabs"
      productUrl="/"
      title="DLT SMS Consent"
      lastUpdated="July 10, 2026"
    >
      <Section>
        <Paragraph>
          This page lists SMS templates registered under India's TRAI Distributed Ledger Technology (DLT) framework for <strong>Spurnest Techlabs</strong>. By providing your mobile number, you consent to receive SMS messages as described below.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Registered Entity</SectionTitle>
        <List>
          <li><strong>Entity:</strong> Spurnest Techlabs</li>
          <li><strong>PE ID:</strong> [Your DLT Principal Entity ID — to be updated]</li>
          <li><strong>Sender Header:</strong> [Your registered 6-character header — to be updated]</li>
          <li><strong>Address:</strong> Gandhinagar, Gujarat 382610, India</li>
        </List>
      </Section>

      <Section>
        <SectionTitle>Registered SMS Templates</SectionTitle>
        <div tw="overflow-x-auto">
          <Table>
            <thead>
              <tr>
                <Th>Template ID</Th>
                <Th>Type</Th>
                <Th>Product</Th>
                <Th>Sample Message</Th>
              </tr>
            </thead>
            <tbody>
              {templates.map((t) => (
                <tr key={t.id}>
                  <Td>{t.id}</Td>
                  <Td>{t.type}</Td>
                  <Td>{t.product}</Td>
                  <Td>{t.message}</Td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <Paragraph tw="text-sm text-gray-500">
          Template IDs marked above are placeholders. Replace with your actual DLT-registered template IDs from your telecom portal.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Your Consent</SectionTitle>
        <Paragraph>
          By entering your mobile number and requesting an OTP, you consent to receive transactional and OTP SMS messages from Spurnest Techlabs for the products listed above. Promotional messages are sent only if you opt in.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Opt-Out</SectionTitle>
        <Paragraph>
          To stop receiving promotional SMS, reply STOP to any promotional message or email{" "}
          <a href="mailto:info@spurnest.com" tw="text-primary-500 font-semibold">info@spurnest.com</a>.
          OTP and transactional messages required for service operation cannot be opted out while your account is active.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Contact</SectionTitle>
        <Paragraph>
          Email: <a href="mailto:info@spurnest.com" tw="text-primary-500 font-semibold">info@spurnest.com</a>
          <br />
          Phone: <a href="tel:+918460407942" tw="text-primary-500 font-semibold">+91 84604 07942</a>
        </Paragraph>
      </Section>
    </LegalPageLayout>
  );
};
